
import { useEffect, useState } from "react"

import { useParams } from "react-router"

import { Box, Paper, Tabs, Tab } from "@mui/material"

import { TabProps, TabPanel } from "../../../helpers/TabPanel"

import { Layout } from "../../../components/Layout"
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion"
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente"
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator"
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado"
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado"
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado"

import { Anexos } from "../ui/Anexos";
import { Asistentes } from "../ui/Asistentes";
import { Notificacion } from "../ui/Notificacion";
import { AcordarPromociones } from "../ui/AcordarPromociones";
import { InformacionAudiencia } from "../ui/InformacionAudiencia";

import { DetalleAudiencia } from "../../../connections/audiencias/AudienciaConnection"

import { AnexoProps } from "../../../interfaces/comun/AnexoInterface"
import { NotificacionesProps } from "../../../interfaces/notificaciones/NotificacionesInterface"
import { AudienciaProps, AsistenteProps, defaultAudiencia, PromocionesProps } from "../../../interfaces/audiencias/AudienciaInterface"

export const CelebrarAudienciaPage = () => {

    const { Id } = useParams();

    const [value, setValue] = useState( 0 );

    const [audiencia, setAudiencia] = useState<AudienciaProps>( defaultAudiencia );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [loading, setLoading] = useState( true );

    const [asistentes, setAsistentes] = useState<AsistenteProps[]>( [] );
    const [notificaciones, setNotificaciones] = useState<NotificacionesProps[]>( [] );
    const [anexos, setAnexos] = useState<AnexoProps[]>( [] );
    const [promociones, setPromociones] = useState<PromocionesProps[]>( [] );

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => setValue( newValue )

    const handleFinalizar = async ( usuarioAsignado: string ) => {

        setProcesoTerminado( true );
        setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

    }

    useEffect(() => {

        async function Obtener() {

            setLoading( true );

            await DetalleAudiencia( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setAudiencia( resp );
                        setAsistentes( resp.asistentes );
                        setNotificaciones( resp.notificaciones );
                        setAnexos( resp.anexos );
                        setPromociones( resp.promociones );

                        if ( resp.idEstatus === 3 ) {

                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.idEstatus === 4 ) {

                            setProcesoCancelado( true );
                            setLoading( false );

                        }
                        else if ( !resp.asignadoMismoUsuario ) {

                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 30 ) {

                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 30 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={[ { text: 'Gestionar audiencia' }, { text: 'Celebrar audiencia' } ]} backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ audiencia.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label="Información de la audiencia" {...TabProps(0)} />
                                        <Tab label="Asistentes en la audiencia" {...TabProps(1)} />
                                        <Tab label="Notificación" {...TabProps(2)} />
                                        <Tab label="Anexo(s)" {...TabProps(3)} />
                                        <Tab label="Acordar promociones" {...TabProps(4)} />
                                        <Tab label="Información del expediente" {...TabProps(5)} />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion
                                            numeroSeguimiento={ `GAU-${ audiencia.idAudiencia }` }
                                            fecha={ audiencia.fecha ?? new Date() }
                                            juez={ audiencia.juez }
                                        />

                                        <InformacionAudiencia
                                            audiencia={ audiencia }
                                            callbackFinalizar={ handleFinalizar }
                                        />

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <Asistentes
                                        audiencia={ audiencia }
                                        asistentes={ asistentes }
                                        setAsistentes={ setAsistentes }
                                        partes={ audiencia.expediente.partes }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <Notificacion
                                        audiencia={ audiencia }
                                        notificaciones={ notificaciones }
                                        setNotificaciones={ setNotificaciones }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 3 }>

                                    <Anexos
                                        audiencia={ audiencia }
                                        anexos={ anexos }
                                        setAnexos={ setAnexos }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 4 }>

                                    <AcordarPromociones
                                        audiencia={ audiencia }
                                        promociones={ promociones }
                                        setPromociones={ setPromociones }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 5 }>

                                    <BoxInformacionExpediente expediente={ audiencia.expediente } />

                                </TabPanel>

                            </>
            }

        </Layout>
    )
}
